import TiptapEditor from '../../../components/Tiptap/TiptapEditor';
import { useState } from 'react';
import { Loading } from '../../../components';

import { useMutation } from '@apollo/client';
import { UPDATE_STRATEGY } from '../../bcp/queries';
import { FETCH_PROCESSES_AREAS_WITH_STRATEGY_BY_LOCATION } from '../../dataInputs/queries/processAreas';
import { useParams } from 'react-router';
import { message } from 'antd';

interface CommentaryModalProps {
  strategyId: string;
  mitigationType: string;
  onClose: () => void;
  comment: string;
}

export function CommentaryModal({
  strategyId,
  mitigationType,
  onClose,
  comment,
}: CommentaryModalProps) {
  const params = useParams();
  const locationId = params.locationId!;
  const [errorMessages, setErrorMessages] = useState('');
  const mutation = UPDATE_STRATEGY;

  const [UpdateCommentary, { error }] = useMutation(mutation, {
    refetchQueries: [
      {
        query: FETCH_PROCESSES_AREAS_WITH_STRATEGY_BY_LOCATION,
        variables: { uuid: locationId },
      },
    ],
    awaitRefetchQueries: true,
  });

  const onFinish = async (values: string) => {
    let response;

    try {
      response = await UpdateCommentary({
        variables: {
          data: {
            uuid: strategyId,
            summary: values,
          },
        },
      });

      if (response?.data) {
        setErrorMessages('');
        onClose();
        message.success('Changes saved');
      }
    } catch (e: any) {
      setErrorMessages(e.message);
    }
  };

  if (error) message.error('Error saving changes');

  return (
    <div className="  w-full flex flex-col flex-nowrap mt-8">
      <TiptapEditor onFinished={onFinish} initialContent={comment} />
      <span>{errorMessages}</span>
    </div>
  );
}
